import { useEffect, useState } from 'react';

import Modal from '../../../../components/UI/Modals/Modal';
import {
  selectCalendarAndSlots,
  updateCalendarAndSlotsState,
} from '../../../../store/slices/calendarAndSlots';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import classes from './OpeningHoursModal.module.css';
import CustomDropdown from '../../../../components/UI/Inputs/CustomDropdown';
import PrimaryButtonV2 from '../../../../components/UI/Buttons/PrimaryButtonV2';
import {
  weekdayFromNumberToString,
  weekdayFromStringToNumber,
} from '../../../../utils/calendarUtils';
import { useTranslation } from '../../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  item: any;
  index: number | undefined;
};

const OpeningHoursModal: React.FC<Props> = ({ isOpen, onClose, item, index }) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [weekDay, setWeekDay] = useState('');
  const [capacity, setCapacity] = useState<number>(1);
  const calendarAndSlots = useAppSelector<any>(selectCalendarAndSlots);
  let calendarData: any = Array(calendarAndSlots);
  let calendarItems = [...calendarData[0].calendar_items];

  const handleAddOrUpdate = async (indexToUpdate: number | undefined) => {
    const newCalendarItem = {
      weekday_id: weekdayFromStringToNumber(weekDay),
      start_time: from,
      end_time: to,
      ...(capacity !== 0 && {
        timeslot_capacity: capacity,
      }),
    };

    if (indexToUpdate !== undefined && indexToUpdate < calendarItems.length) {
      calendarItems[indexToUpdate] = newCalendarItem;
    } else {
      calendarItems.push(newCalendarItem);
    }

    let dataToPost = [
      {
        ...calendarData[0],
        calendar_items: calendarItems,
      },
    ];

    dispatch(updateCalendarAndSlotsState(dataToPost[0]));
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      setFrom(item.start_time);
      setTo(item.end_time);
      setWeekDay(weekdayFromNumberToString(item.weekday_id));
      setCapacity(item.timeslot_capacity ? item.timeslot_capacity : 1);
    } else {
      setFrom('');
      setTo('');
      setWeekDay('');
    }
  }, [isOpen]);
  const options = [
    'choose.day',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      containerPadding="20px 10px"
      width="454px"
      header={translations('new.opening').toString()}
    >
      <div className={classes.modalContainer}>
        <div className={classes.inputContainer}>
          <div className={classes.text} style={{ marginBottom: 5 }}>
            {translations('day')}
          </div>
          <CustomDropdown
            dropdownStyle={{
              border: '1px solid #a8aec0',
              height: 37,
              borderRadius: 5,
            }}
            placeholder={translations('day')}
            onChange={(e) => setWeekDay(e.target.value)}
            options={options.map((option) => ({ id: option, label: translations(option) }))}
            value={weekDay}
          />
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.text}>{translations('capacity')}</div>
          <input
            id="cap-time"
            type="number"
            name="cap-time"
            className={classes.textContainer}
            onChange={(e) => setCapacity(Number(e.target.value))}
            value={capacity === 0 ? '' : capacity}
            min={0}
          />
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.text}>{translations('from')}</div>
          <input
            id="appt-time"
            type="time"
            name="appt-time"
            className={classes.textContainer}
            onChange={(e) => setFrom(e.target.value + ':00')}
            value={from}
          />
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.text}>{translations('to')}</div>
          <input
            id="appt-time"
            type="time"
            name="appt-time"
            className={classes.textContainer}
            onChange={(e) => setTo(e.target.value + ':00')}
            value={to}
          />
        </div>
        <PrimaryButtonV2
          buttonStyle={{ width: 410, marginTop: 40, height: 50 }}
          text={translations('add')}
          containerStyle={{}}
          disabled={false}
          onClick={() => handleAddOrUpdate(index)}
        />
      </div>
    </Modal>
  );
};

export default OpeningHoursModal;
